import script from "./ShiftCardSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftCardSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ShiftCardSkeleton.vue?vue&type=style&index=0&id=c856eb00&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c856eb00"]])

export default __exports__